const Footer = ({ appName }) => {
  return (
    <footer className="app-footer">
      <strong>Copyright © {appName}</strong>
      <div className="float-end d-none d-sm-inline">
        <b>Version</b> {process.env.REACT_APP_VERSION}
      </div>
    </footer>
  )
}
 
export default Footer